import * as React from "react";
import styled from "styled-components";
import colors from "theme/colors";


const StyledSVG = styled.svg`
 ${(p) => p.theme.breakpoints.down("sm")} {
    width: 29px;
    height: 22px
}
`

const SvgComponent = ({
    color = colors.black,
}: React.SVGProps<SVGSVGElement>) => {
    const w = 22;
    const h = 22;
    return (
        <StyledSVG
            xmlns="http://www.w3.org/2000/svg"
            width={w}
            height={h}
            viewBox="0 0 38 33"
        >
            <g
                data-name="YouTube icon"
                transform="translate(1.5 1.5)"
            >
                <path
                    data-name="Path 296"
                    d="m52 44.99-4.5 2.5-4.5 2.5v-10l4.5 2.5z"
                    transform="translate(-29.499 -29.99)"
                    fill="none"
                    stroke={color}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2px"
                />
                <rect
                    data-name="Rectangle 1402"
                    width="35"
                    height="30"
                    rx="5"
                    fill="none"
                    stroke={color}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="3px"
                />
            </g>
        </StyledSVG >
    )
}

export default SvgComponent
